"use strict";
// Gewichtsklassifikation (UG/NG/ÜG/AD/EA) from the BMI z-score (LMS). One
// implementation for the Ergebnisblatt box, the nutrition recommendations and
// the Diagramme. The cut-offs are the existing gender-specific thresholds of
// the PDF report / NutritionService; do not change them here alone.
// See documentation/charts.md ("Gewichtsklassen").
Object.defineProperty(exports, "__esModule", { value: true });
exports.BMI_Z_CUTOFFS = exports.WEIGHT_CLASS_UNKNOWN_DE = exports.WEIGHT_CLASS_LABEL_DE = exports.WEIGHT_CLASS_ABBR = exports.WEIGHT_CLASS_KEYS = void 0;
exports.weightClassFromBmiZScore = weightClassFromBmiZScore;
exports.WEIGHT_CLASS_KEYS = [
    "UNDERWEIGHT",
    "NORMAL",
    "OVERWEIGHT",
    "OBESE",
    "EXTREME_OBESE",
];
exports.WEIGHT_CLASS_ABBR = {
    UNDERWEIGHT: "UG",
    NORMAL: "NG",
    OVERWEIGHT: "ÜG",
    OBESE: "AD",
    EXTREME_OBESE: "EA",
};
/** German labels as printed on the Ergebnisblatt. */
exports.WEIGHT_CLASS_LABEL_DE = {
    UNDERWEIGHT: "Untergewicht",
    NORMAL: "Normalgewicht",
    OVERWEIGHT: "Übergewicht",
    OBESE: "Adipositas",
    EXTREME_OBESE: "extreme Adipositas",
};
/** Label for timepoints/children without a classification. */
exports.WEIGHT_CLASS_UNKNOWN_DE = "keine Angabe";
/** Gender-specific BMI z cut-offs (boys / girls). */
exports.BMI_Z_CUTOFFS = {
    MALE: {
        underweightBelow: -1.014,
        normalMax: 1.31,
        overweightMax: 2.288,
        obeseMax: 2.93,
    },
    FEMALE: {
        underweightBelow: -0.975,
        normalMax: 1.244,
        overweightMax: 2.192,
        obeseMax: 2.822,
    },
};
/**
 * Weight class of a BMI z-score. Returns null when the z-score is missing or
 * not finite, or the gender is unknown (no classification possible).
 */
function weightClassFromBmiZScore(zScore, gender) {
    if (zScore === null || zScore === undefined || !Number.isFinite(zScore)) {
        return null;
    }
    if (gender !== "MALE" && gender !== "FEMALE")
        return null;
    const c = exports.BMI_Z_CUTOFFS[gender];
    if (zScore < c.underweightBelow)
        return "UNDERWEIGHT";
    if (zScore <= c.normalMax)
        return "NORMAL";
    if (zScore <= c.overweightMax)
        return "OVERWEIGHT";
    if (zScore <= c.obeseMax)
        return "OBESE";
    return "EXTREME_OBESE";
}
